export default "__VITE_ASSET__382f786e__"